import { render, staticRenderFns } from "./ResultSecond.vue?vue&type=template&id=226d5e18"
import script from "./ResultSecond.vue?vue&type=script&lang=js"
export * from "./ResultSecond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports